const GUEST_ACCESS_KEY = "guestAccessExpiresAt";
const GUEST_LOCK_KEY = "guestAccessLocked";
const GUEST_WINDOW_MS = 5 * 60 * 1000;

export function clearGuestAccess() {
  localStorage.removeItem(GUEST_ACCESS_KEY);
  localStorage.removeItem(GUEST_LOCK_KEY);
}

export function lockGuestAccess() {
  localStorage.removeItem(GUEST_ACCESS_KEY);
  localStorage.setItem(GUEST_LOCK_KEY, "1");
}

export function getGuestAccessState() {
  if (localStorage.getItem(GUEST_LOCK_KEY) === "1") {
    return { status: "expired", expiresAt: 0 };
  }

  const stored = localStorage.getItem(GUEST_ACCESS_KEY);
  let expiresAt = Number(stored);

  if (!stored || Number.isNaN(expiresAt)) {
    expiresAt = Date.now() + GUEST_WINDOW_MS;
    localStorage.setItem(GUEST_ACCESS_KEY, expiresAt.toString());
  }

  if (expiresAt <= Date.now()) {
    lockGuestAccess();
    return { status: "expired", expiresAt: 0 };
  }

  return { status: "guest", expiresAt };
}
